module.exports = __webpack_public_path__ + "img/icon-gen-viewpayout.0c3c4c48.png";